import logo from '../../../assets/logo_gm_purple.png';

/**
 * Marca GM (General Motors Design System).
 * - Primary (Action): #0372CF
 * - Primary (Sober): #194390
 * - Support 1: #5C93CC
 * - Support 2: #86C1E2
 * - Neutral Background: #FFFFFF
 * - Neutral Text: #212529
 */
const palette = {
  primary: {
    main: '#0372CF',
    dark: '#194390',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#5C93CC',
    light: '#86C1E2',
    contrastText: '#FFFFFF',
  },
};

const gm = {
  name: 'GM',
  // Sem versão clara do logo para o dark: useBrand cai no logo do light.
  logo: { light: logo },
  themeOptions: {
    colorSchemes: {
      light: {
        palette: {
          ...palette,
          background: { default: '#FFFFFF' },
          text: { primary: '#212529', secondary: '#6C757D' },
        },
      },
      dark: { palette },
    },
  },
};

export default gm;
